import { socialChannelIdsOnPieces } from '@/app/common/brief-pieces/piece-rules';
import { Piece, SocialChannelEnum } from '../../common/general-types/briefs.dto';

export interface ManageBriefTabSource {
  shoutBrief?: { socialPlatform?: number | null } | null;
  pieces?: readonly Piece[] | null;
}

/** Reporting is for any brief that asks creators to publish on a social network. */
export function showsReportingTab(brief: ManageBriefTabSource | null | undefined): boolean {
  return hasShoutBrief(brief) || socialChannelIds(brief).length > 0;
}

/** Ads, Spark Ads, and Performance stay TikTok-only, including TikTok pieces. */
export function showsTikTokAdsTabs(brief: ManageBriefTabSource | null | undefined): boolean {
  if (brief?.shoutBrief?.socialPlatform === SocialChannelEnum['TikTok Post']) {
    return true;
  }
  return socialChannelIds(brief).includes(SocialChannelEnum['TikTok Post']);
}

function hasShoutBrief(brief: ManageBriefTabSource | null | undefined): boolean {
  return brief?.shoutBrief != null;
}

function socialChannelIds(brief: ManageBriefTabSource | null | undefined): number[] {
  return socialChannelIdsOnPieces(brief?.pieces ?? []);
}
